import React, { useState } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import ClientList from './components/ClientList';
import FileUpload from './components/FileUpload';
import ProcessingStatus from './components/ProcessingStatus';
import FileExplorer from './components/FileExplorer';
import LoginPage from './components/LoginPage';
import AuthCallbackPage from './components/AuthCallbackPage';
import ProtectedRoute from './components/ProtectedRoute';
import { useAuth } from './auth/AuthContext';

function App() {
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [currentJob, setCurrentJob] = useState(null);
  const { isAuthenticated, signOut, user } = useAuth();

  return (
    <div className="app">
      <header className="header">
        <div className="container header-content">
          <Link to="/" className="logo">AmandaMD</Link>
          <nav className="nav-links">
            <Link to="/">Clients</Link>
            <Link to="/upload">Upload</Link>
            <Link to="/status">Status</Link>
            {isAuthenticated ? (
              <button
                type="button"
                className="btn btn-secondary"
                onClick={signOut}
                style={{ marginLeft: '0.75rem' }}
              >
                Sign Out
              </button>
            ) : (
              <Link to="/login">Sign In</Link>
            )}
          </nav>
        </div>
      </header>

      <main className="main">
        <div className="container">
          {isAuthenticated && user?.email && (
            <div className="text-sm text-muted mb-4">Signed in as {user.email}</div>
          )}
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/auth/callback" element={<AuthCallbackPage />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <ClientList
                    clients={clients}
                    setClients={setClients}
                    onSelectClient={setSelectedClient}
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/upload"
              element={
                <ProtectedRoute>
                  <FileUpload
                    selectedClient={selectedClient}
                    onJobCreated={setCurrentJob}
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/status"
              element={
                <ProtectedRoute>
                  <ProcessingStatus
                    currentJob={currentJob}
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/status/:jobId"
              element={
                <ProtectedRoute>
                  <ProcessingStatus />
                </ProtectedRoute>
              }
            />
            <Route
              path="/files/:clientId"
              element={
                <ProtectedRoute>
                  <FileExplorer />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </main>
    </div>
  );
}

export default App;
